import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import * as React from 'react';
import { useValueRef } from '@cian/react-utils';
import { useControlledRef } from '../../../../internal/hooks';
export function useCheckboxGroupOptions(props) {
  var options = props.options;
  var propsRef = useValueRef(props);
  var _useControlledRef = useControlledRef({
      controlled: props.value,
      default: props.defaultValue || []
    }),
    _useControlledRef2 = _slicedToArray(_useControlledRef, 2),
    valueRef = _useControlledRef2[0],
    setValue = _useControlledRef2[1];
  return React.useMemo(function () {
    return options.map(function (option) {
      return _objectSpread(_objectSpread({}, option), {}, {
        onChange: function onChange(e) {
          var optionValue = option.value;
          var onChange = propsRef.current.onChange;
          if (!onChange) {
            return;
          }
          var prevValue = valueRef.current;
          var isChecked = prevValue.includes(optionValue);
          if (isChecked) {
            setValue(prevValue.filter(function (v) {
              return v !== optionValue;
            }));
          } else {
            setValue([].concat(_toConsumableArray(prevValue), [optionValue]));
          }
          onChange(e, valueRef.current);
        }
      });
    });
  }, [options, propsRef, valueRef, setValue]);
}